import { render, staticRenderFns } from "./create-project-dialog.vue?vue&type=template&id=b9307ffa&"
import script from "./create-project-dialog.vue?vue&type=script&lang=js&"
export * from "./create-project-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports